import { useEffect } from 'react'
import ScrollReveal from 'scrollreveal'

export const useScrollReveal = () => {
  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'top',
      distance: '60px',
      duration: 2100,
      delay: 280,
      reset: true
    })

    sr.reveal(`.section__title`, {
      delay: 200
    })

    sr.reveal(`.section__subtitle`, {
      delay: 300
    })

    sr.reveal(`.home__title`, {
      delay: 400
    })

    sr.reveal(`.home__subtitle`, {
      delay: 500
    })

    sr.reveal(`.home__elec`, {
      delay: 600
    })

    sr.reveal(`.home__img`, {
      delay: 600
    })

    sr.reveal(`.home__car-data`, {
      delay: 700,
      interval: 100,
      origin: 'bottom'
    })

    sr.reveal(`.home__button`, {
      delay: 800,
      origin: 'bottom'
    })

    sr.reveal(`.about__group`, {
      origin: 'left'
    })

    sr.reveal(`.about__data`, {
      origin: 'right'
    })

    sr.reveal(`.features__map`, {
      delay: 400,
      origin: 'bottom'
    })

    sr.reveal(`.features__card`, {
      interval: 300
    })

    sr.reveal(`.featured__card`, {
      interval: 100
    })

    sr.reveal(`.featured__filters`, {})

    // sr.reveal(`.offer__data`, {
    //   origin: 'left'
    // })

    // sr.reveal(`.offer__img`, {
    //   origin: 'right'
    // })

    // sr.reveal(`.logos__content`, {
    //   interval: 100
    // })

    // sr.reveal(`.footer__content`, {
    //   interval: 100
    // })

  }, [])
}